export default "__VITE_ASSET__CapFH33u__"